import { useUouLanguageContext } from '../context/UouLanguageContext';

export function useUouLanguage() {
  const context = useUouLanguageContext();

  return context.language!;
}
